export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    fixed: 'left',
    type: 'seq'
  },
  {
    field: 'col-opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    headerAlign: 'center',
    align: 'center',
    fixed: 'right',
    width: 150,
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'opt'
    }
  },
  {
    title: that.$l('table_label_tcExpenseNo') || 'TC采购请款单编号',
    field: 'tcExpenseNo',
    minWidth: 150,
    align: 'center',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_salesPersonName') ||'业务人员',
    field: 'salesPersonName',
    width: 150,
    align: 'left',
    headerAlign: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_requestDate') ||'申请日期',
    field: 'requestDate',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_estimatedPaymentDate') ||'预计付款日期',
    field: 'estimatedPaymentDate',
    width: 120,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.Status') ||'状态',
    field: 'tcExpenseStatus',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'status'
    }
  },
  {
    title: that.$l('table_label_tcRequestType') ||'TC请款类型',
    field: 'v_tcRequestType',
    minWidth: 150,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_payeeScmName') ||'收款供应商',
    field: 'payeeScmName',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_currencyAmount') ||'费用合计',
    field: 'v_currencyAmount',
    minWidth: 140,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: {
      default: 'showAmount'
    }
  },
  {
    title: that.$l('table_label_expensePayerName') ||'费用付款方',
    field: 'expensePayerName',
    minWidth: 200,
    headerAlign: 'center',
    align: 'left',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('table_label_paymentMethod') ||'付款方式',
    field: 'v_paymentMethod',
    width: 100,
    headerAlign: 'center',
    align: 'center',
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_bank_name') || '开户银行',
    field: 'bankName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 220,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_bank_account_name') || '账户名称',
    field: 'bankAccountName',
    headerAlign: 'center',
    align: 'center',
    minWidth: 200,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_bank_account_no') || '银行账号',
    field: 'bankAccountNo',
    headerAlign: 'center',
    align: 'center',
    minWidth: 200,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_bank_account_type') || '账户性质',
    field: 'v_bankAccountType',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_bank_account_kind') || '账号类别',
    field: 'v_bankAccountKind',
    headerAlign: 'center',
    align: 'center',
    minWidth: 100,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_created_by') || '创建人',
    field: 'createByName',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_created_date') || '创建时间',
    field: 'createTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    field: 'modifyByName',
    headerAlign: 'center',
    align: 'center',
    width: 120,
    showHeaderOverflow: true,
    showOverflow: true
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyTime',
    headerAlign: 'center',
    align: 'center',
    width: 170,
    showHeaderOverflow: true,
    showOverflow: true
  }
]
